












































































































































import mixins from 'vue-typed-mixins';
import EmailUtils, { AutomatedEmail } from '@/utils/EmailUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => AutomatedEmail,
    },
  },

  computed: {
    types(): AutomatedEmail['type'][] {
      return ['user', 'organization', 'survey', 'signature'];
    },

    signaturesOptions(): any {
      return this.signatures?.map((signature) => ({
        text: `${signature.name} (${signature.key})`,
        value: signature,
      }));
    },

    useDefaultSignature: {
      get(): boolean {
        return !this.value.signature;
      },
      set(useDefaultSignature: boolean) {
        if (useDefaultSignature) {
          this.value.signature = null;
          if (this.signatures?.length === 1) {
            this.value.defaultsignature = this.signatures[0];
          } else {
            this.value.defaultsignature = null;
          }
        } else {
          this.value.signature = this.$languageobj(undefined, undefined, {
            additional_locales: ['multi'],
          });
          this.value.defaultsignature = null;
        }
      },
    },
    isDisabled(): any {
      return this.value.system;
    },
  },

  data(): {
    signatures?: AutomatedEmail[];
  } {
    return {
      signatures: undefined,
    };
  },

  async mounted() {
    try {
      this.signatures = await EmailUtils.api.list({ type: 'signature' });
      if (this.useDefaultSignature) {
        if (this.signatures?.length === 1) {
          this.value.defaultsignature = this.signatures[0];
        } else if (this.value.defaultsignature !== undefined) {
          this.value.defaultsignature = this.signatures?.find(
            (signature) => this.value.defaultsignature?.id === signature.id
          );
        }
      }
    } catch (error) {
      this.$alert.show('signatures', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  watch: {
    'value.type'(
      type: AutomatedEmail['type'],
      previous: AutomatedEmail['type']
    ) {
      if (type === 'signature') {
        this.useDefaultSignature = false;
      } else if (previous === 'signature') {
        this.useDefaultSignature = true;
      }
    },
  },
});
